import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Home from "./Home";
import MisVis from "./MisVis";
import About from "./About";
import Contact from "./Contact";
import "../styles/Home.css"
import EventsGallery from "./EventsGallery";

const pageVariants = {
    initial: {
        opacity: 0,
        y: 30
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: "easeOut"
        }
    },
    exit: {
        opacity: 0,
        y: -30,
        transition: {
            duration: 0.4,
            ease: "easeIn"
        }
    }
};

const AnimatedRoutes = () => {
    const location = useLocation();

    return (
        <div className="Appy">
            <AnimatePresence mode="wait">
                <Routes location={location} key={location.pathname}>
                    <Route
                        path="/"
                        element={
                            <motion.div
                                variants={pageVariants}
                                initial="initial"
                                animate="animate"
                                exit="exit"
                            >
                                <Home />
                            </motion.div>
                        }
                    />

                    <Route
                        path="/Mission-vission"
                        element={
                            <motion.div
                                variants={pageVariants}
                                initial="initial"
                                animate="animate"
                                exit="exit"
                            >
                                <MisVis />
                            </motion.div>
                        }
                    />

                    <Route
                        path="Events-gallery"
                        element={
                            <motion.div
                                variants={pageVariants}
                                initial="initial"
                                animate="animate"
                                exit="exit"
                            >
                                <EventsGallery />
                            </motion.div>
                        }
                    />

                    <Route
                        path="/About"
                        element={
                            <motion.div
                                variants={pageVariants}
                                initial="initial"
                                animate="animate"
                                exit="exit"
                            >
                                <About />
                            </motion.div>
                        }
                    />

                    <Route
                        path="/Contact"
                        element={
                            <motion.div
                                variants={pageVariants}
                                initial="initial"
                                animate="animate"
                                exit="exit"
                            >
                                <Contact />
                            </motion.div>
                        }
                    />
                </Routes>
            </AnimatePresence>
        </div>
    );
};

export default AnimatedRoutes;
